export const getOpsUrl = () => {
    if (
        window.origin === "https://accounting-dev.request.finance" ||
        window.origin === "http://localhost:3000"
    ) {
        return "https://croissant-app.request.finance";
    }

    if (window.origin === "https://accounting-staging.request.finance") {
        return "https://baguette-app.request.finance";
    }
    return "https://app.request.finance";
};
